import React from 'react'
import {AccordionItem} from 'hec/components/ui/accordion'
import {useAccordionContext} from './accordionContext'

interface CustomAccordionItemProps {
    className?: string
    renderContent?: () => React.ReactNode
}

export const CustomAccordionItem: React.FC<CustomAccordionItemProps> = ({
    className,
    renderContent,
    ...props
}) => {
    const {itemIndex} = useAccordionContext()

    return (
        <AccordionItem
            value={`item-${itemIndex}`}
            key={itemIndex}
            className={className}
            {...props}
            data-testid="accordionItem-AccordionItem"
        >
            {renderContent?.()}
        </AccordionItem>
    )
}
